import bus_4 from '../img/bus/bus_4.jpg';
import { useRef } from 'react';
import { useTranslation } from "react-i18next";

export default function Bus({ headingLevel = 'h1' }) {
    const anchorRef = useRef(null);
    const { t } = useTranslation();
    const Heading = headingLevel;

    return(
        <div className="container" style={{marginTop: '170px'}} id="bus" ref={anchorRef}>
            <div className="homepageContent homepageContentImg" style={{alignItems: 'flex-start'}}>
                <div className="homepageImg">
                    <img src={bus_4} alt="IGGI Izbraukumi" style={{objectPosition: 'bottom'}} />
                </div>
                <div className="homepageText">
                    <Heading>{ t('bus.title') }</Heading>
                    <p dangerouslySetInnerHTML={{ __html: t('bus.description') }} />
                </div>
            </div>
        </div>
    )
}
